export const DEFAULT_RECHARGE_VIEW = "default";
export const DEBIT_CARD_VIEW = "debit-card";

export type RechargeViewMode =
  | typeof DEFAULT_RECHARGE_VIEW
  | typeof DEBIT_CARD_VIEW;
